import { FunctionComponent } from 'react'
import { ThemeInterface } from 'theme/types'
import images from '../../images.json'
import { LoadingDiv, Logo, Spinner } from '../../theme/loading'
import Theme from '../../theme/schema.json'

const LoadingScreen: FunctionComponent = () => {
  const theme = Theme.data[THEME] as ThemeInterface
  return (
    <LoadingDiv className="z-50">
      <div className="absolute " style={{ left: '50%', top: '50%', transform: 'translate(-50%, -50%)', zIndex: 1000 }}>
        <Spinner src={`${AZURE_BASE_URL}${images['loader-spinner']}`} className="animate-spin animation-8" />
      </div>
      {!theme.loading.config.hideSpinningLogo && (
        <Logo
          src={`${AZURE_BASE_URL}${images['logo-positivo-svg']}`}
          className="absolute"
          style={{ left: '50%', top: '50%', transform: 'translate(-50%, -50%)', zIndex: 1050 }}
        />
      )}
    </LoadingDiv>
  )
}
export default LoadingScreen
